import { IconButton, Modal } from "src/Components";
import { ReactComponent as PauseIcon } from "../../Assets/Cup-modal.svg";
import { IModalProps } from "..";
import "./ReturnEndPauseConfirmModal.scss";

const ReturnEndPauseConfirmModal: React.FC<IModalProps> = ({ isOpen, onClose, onAction }) => (
	<Modal
		isOpen={isOpen}
		title="Подтверждение действий"
		onClose={onClose}
		className="return-end-pause-confirm-modal"
		renderIcon={<PauseIcon />}
		renderFooter={(
			<>
				<IconButton outline onClick={onClose}>Продолжить</IconButton>
				<IconButton color="green" onClick={() => onAction("return-confirm-end-pause")}>Завершить перерыв</IconButton>
			</>
		)}
	>
		Закончить отдых и вернуться к работе?
	</Modal>
);

export default ReturnEndPauseConfirmModal;
